/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./RadioButtonGroup.css'); }
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-radioButtonGroup");
var RadioButtonGroup = /** @class */ (function (_super) {
    tslib_1.__extends(RadioButtonGroup, _super);
    function RadioButtonGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnChange = function (event, value) {
            if (_this.props.onChange) {
                _this.props.onChange(event, value);
            }
        };
        return _this;
    }
    RadioButtonGroup.prototype.getChildContext = function () {
        return {
            name: this.props.name,
            value: this.props.value,
            disabled: this.props.disabled,
            onChange: this.handleOnChange
        };
    };
    RadioButtonGroup.prototype.render = function () {
        var bordered = this.props.bordered;
        return (React.createElement("div", { className: classnames(moduleClassName(), bordered && moduleClassName("isBordered")) }, this.props.children));
    };
    RadioButtonGroup.propTypes = {
        name: PropTypes.string.isRequired,
        value: PropTypes.string,
        disabled: PropTypes.bool,
        bordered: PropTypes.bool,
        onChange: PropTypes.func
    };
    RadioButtonGroup.childContextTypes = {
        name: PropTypes.string.isRequired,
        value: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func
    };
    RadioButtonGroup.defaultProps = {
        disabled: false
    };
    return RadioButtonGroup;
}(React.Component));
exports.RadioButtonGroup = RadioButtonGroup;